var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.102 3.005A1 1 0 0121 4v16l-.005.102a1 1 0 01-.893.893L20 21H4a1 1 0 01-.995-.898L3 20V4a1 1 0 011-1h16l.102.005zM4.5 19.5H9V16H7.5l-.103-.005A1 1 0 016.5 15v-2.5a1 1 0 011-1H9V10a5 5 0 015-5h2.5a1 1 0 011 1v2.25a1 1 0 01-1 1h-2.25a.75.75 0 00-.75.75v1.5h2.253a1 1 0 01.977 1.217l-.556 2.5a1 1 0 01-.804.768l-.172.015H13.5v3.5h6v-15h-15v15zm9.5-13a3.5 3.5 0 00-3.5 3.5v3H8v1.5h2.5v5H12v-5h2.797l.334-1.5H12v-3a2.25 2.25 0 012.25-2.25H16V6.5h-2z",
    fill: "currentColor"
  })));
}
SvgFacebook.displayName = 'Facebook';
export default SvgFacebook;